"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Language = exports.CurrencyCode = exports.Locale = exports.LanguageCode = void 0;
var LanguageCode;

(function (LanguageCode) {
  LanguageCode["en"] = "en";
  LanguageCode["fr"] = "fr";
  LanguageCode["es"] = "es";
})(LanguageCode || (exports.LanguageCode = LanguageCode = {}));

var Locale;

(function (Locale) {
  Locale["us"] = "en-us";
  Locale["ca"] = "en-ca";
  Locale["mx"] = "es-mx";
  Locale["cn"] = "en-us"; // The CN is not supported by Price Util
})(Locale || (exports.Locale = Locale = {}));

var CurrencyCode;

(function (CurrencyCode) {
  CurrencyCode["us"] = "USD";
  CurrencyCode["ca"] = "CAD";
  CurrencyCode["mx"] = "MXN";
  CurrencyCode["cn"] = "USD"; // The CN is not supported by Price Util
})(CurrencyCode || (exports.CurrencyCode = CurrencyCode = {}));

var Language;

(function (Language) {
  Language["EnglishUS"] = "en-us";
  Language["SpanishMexican"] = "es-mx";
  Language["FrenchCanadian"] = "fr-ca";
})(Language || (exports.Language = Language = {}));